import tg from "../../asset-source/tg.svg";

import footer from "../../asset-source/footer.png";
import ContactUsModal from "../modal/contact-us";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Footer = ({ backgroundColor = "#fff" }) => {
	const navigate = useNavigate();

	// useEffect(() => {
	// 	if (modal) {
	// 		document.body.style.overflow = "hidden";
	// 	} else {
	// 		document.body.style.overflow = "auto";
	// 	}
	// }, [modal]);

	return (
    <div
      style={{
        background: backgroundColor,
      }}
      className="footer__constructor"
    >
      <footer className="footer newfooter">
        <img src={footer} alt="" className="decor" />
        <div>
          <div className="footer__hat">
            Проектирование, дизайн и разработка цифровых продуктов
          </div>
          <div className="footer__title">Хотите с нами работать?</div>
          <div className="newfooter__contacts">
            <button
              className="newfooter__contactitem"
              onClick={() => {
                navigate(`?modal`);
              }}
            >
              Расскажите о своём проекте
            </button>

            <a
              href="https://t.me/wjet_io"
              target="_blank"
              className="newfooter__contactitem"
              rel="noreferrer"
            >
              Напишите нам в телеграм:
              <img src={tg} alt="" className="" />
            </a>
          </div>

          <div className="newfooter__caption">
            Мы свяжемся с вами в течение рабочего дня
          </div>
        </div>

        <div>
          <div className="newfooter__socials">
            {/* <a href="#" target="_blank" rel="noreferrer">
							<svg
								width="40"
								height="40"
								viewBox="0 0 40 40"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="socialMediaIcons" clip-path="url(#clip0_2407_31636)">
									<path
										id="Vector"
										d="M37.0391 0H2.95312C1.32031 0 0 1.28906 0 2.88281V37.1094C0 38.7031 1.32031 40 2.95312 40H37.0391C38.6719 40 40 38.7031 40 37.1172V2.88281C40 1.28906 38.6719 0 37.0391 0ZM11.8672 34.0859H5.92969V14.9922H11.8672V34.0859ZM8.89844 12.3906C6.99219 12.3906 5.45312 10.8516 5.45312 8.95312C5.45312 7.05469 6.99219 5.51562 8.89844 5.51562C10.7969 5.51562 12.3359 7.05469 12.3359 8.95312C12.3359 10.8438 10.7969 12.3906 8.89844 12.3906ZM34.0859 34.0859H28.1562V24.8047C28.1562 22.5938 28.1172 19.7422 25.0703 19.7422C21.9844 19.7422 21.5156 22.1562 21.5156 24.6484V34.0859H15.5938V14.9922H21.2812V17.6016H21.3594C22.1484 16.1016 24.0859 14.5156 26.9688 14.5156C32.9766 14.5156 34.0859 18.4688 34.0859 23.6094V34.0859Z"
										fill="#E8E8E8"
									/>
								</g>
								<defs>
									<clipPath id="clip0_2407_31636">
										<rect width="40" height="40" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</a> */}

            <a
              href="https://www.behance.net/wjetstudio"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="behance-svgrepo-com-2 1">
                  <g clip-path="url(#clip0_2407_31638)">
                    <g id="Group">
                      <path
                        id="Vector"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.0978 21.6015C14.5545 21.1894 13.8299 20.9844 12.9385 20.9844H8.43652V26.1636H12.8555C13.2643 26.1636 13.652 26.1274 14.0168 26.0458C14.3871 25.9648 14.7156 25.8365 14.9925 25.6468C15.2694 25.4644 15.4988 25.2144 15.6656 24.8964C15.8329 24.5812 15.9131 24.1718 15.9131 23.6773C15.9131 22.7077 15.6404 22.0197 15.0978 21.6015Z"
                        fill="#E8E8E8"
                      />
                      <path
                        id="Vector_2"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.4489 17.6303C14.9253 17.2826 15.1562 16.708 15.1562 15.9199C15.1562 15.4822 15.0795 15.1205 14.9253 14.8399C14.7656 14.5592 14.5543 14.3395 14.2871 14.1857C14.0221 14.0257 13.7229 13.9151 13.3755 13.8555C13.0345 13.7888 12.6767 13.7627 12.3105 13.7627H8.43616V18.1576H12.6265C13.3603 18.1576 13.9678 17.9836 14.4489 17.6303Z"
                        fill="#E8E8E8"
                      />
                      <path
                        id="Vector_3"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.18056 -1.94434C-0.852157 -1.94434 -2.5 -0.296495 -2.5 1.73622V38.5418C-2.5 40.5745 -0.852159 42.2223 1.18056 42.2223H37.9861C40.0188 42.2223 41.6667 40.5745 41.6667 38.5418V1.73622C41.6667 -0.296493 40.0188 -1.94434 37.9861 -1.94434H1.18056ZM24.2559 11.8203H31.8797V13.6763H24.2559V11.8203ZM19.4965 26.3715C19.1283 27.0708 18.6268 27.6374 18.0088 28.0747C17.386 28.5159 16.6704 28.8394 15.869 29.0501C15.0767 29.2607 14.2537 29.3667 13.4112 29.3667H4.29487V10.5586H13.1623C14.062 10.5586 14.8738 10.6364 15.6159 10.7972C16.3538 10.9538 16.9836 11.215 17.5158 11.5731C18.0395 11.9313 18.4497 12.4076 18.7432 13.0078C19.0298 13.5989 19.1736 14.3393 19.1736 15.2146C19.1736 16.1614 18.9588 16.9522 18.5292 17.5844C18.096 18.2156 17.46 18.7335 16.6098 19.1356C17.7675 19.4682 18.6248 20.0542 19.1931 20.8872C19.7644 21.726 20.044 22.7295 20.044 23.9062C20.0439 24.8599 19.8612 25.6812 19.4965 26.3715ZM34.848 23.458H25.021C25.021 24.5345 25.385 25.5538 25.9472 26.1009C26.5072 26.6481 27.317 26.9232 28.3659 26.9232C29.1205 26.9232 29.7726 26.7325 30.3194 26.3523C30.8614 25.9726 31.1912 25.5666 31.3189 25.1451H34.6129C34.0836 26.7844 33.2801 27.9547 32.1844 28.6592C31.1013 29.3667 29.7802 29.7193 28.2411 29.7193C27.1684 29.7193 26.2031 29.5456 25.3362 29.2036C24.4699 28.8572 23.746 28.3719 23.1371 27.7393C22.5436 27.1035 22.0826 26.3524 21.7541 25.4698C21.4291 24.592 21.2652 23.6201 21.2652 22.5669C21.2652 21.5486 21.4353 20.5973 21.768 19.7181C22.1076 18.8358 22.5771 18.0746 23.1943 17.4361C23.8129 16.7941 24.5466 16.2874 25.401 15.9174C26.2554 15.5488 27.1976 15.3633 28.2411 15.3633C29.3932 15.3633 30.4024 15.585 31.2673 16.0366C32.1293 16.482 32.8359 17.0857 33.391 17.8414C33.9461 18.5957 34.3409 19.4584 34.5879 20.4261C34.8327 21.3922 34.9185 22.4014 34.848 23.458Z"
                        fill="#E8E8E8"
                      />
                      <path
                        id="Vector_4"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M28.1287 18.1877C27.531 18.1877 27.0365 18.2882 26.6404 18.4932C26.2533 18.6955 25.936 18.9472 25.6933 19.2437C25.452 19.545 25.2874 19.863 25.1918 20.203C25.0956 20.5343 25.0385 20.8349 25.021 21.1007H31.107C31.0177 20.1469 30.6912 19.4418 30.2449 18.946C29.8005 18.4538 29.0472 18.1877 28.1287 18.1877Z"
                        fill="#E8E8E8"
                      />
                    </g>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_2407_31638">
                    <rect width="40" height="40" rx="3.33333" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <a href="https://t.me/wjet_studio" target="_blank" rel="noreferrer">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_4365_194939)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM6.85611 19.4709C14.1039 16.3661 18.9368 14.3193 21.355 13.3304C28.2594 10.5069 29.6941 10.0164 30.6292 10.0002C30.8349 9.99661 31.2947 10.0467 31.5926 10.2844C31.8441 10.485 31.9133 10.7561 31.9464 10.9464C31.9795 11.1366 32.0208 11.57 31.988 11.9087C31.6138 15.7739 29.9949 25.1538 29.1713 29.483C28.8228 31.3148 28.1365 31.929 27.4722 31.9891C26.3289 32.0925 25.4034 31.4439 24.3734 30.7218C24.1027 30.5321 23.8247 30.3373 23.5337 30.1497C22.3915 29.4135 21.5086 28.8224 20.6235 28.2298C19.813 27.6871 19.0006 27.1431 17.9854 26.4853C15.8727 25.1165 16.7571 24.2783 17.9364 23.1605L17.9364 23.1605C18.1273 22.9795 18.326 22.7913 18.5209 22.5922C18.6079 22.5034 19.0334 22.1144 19.6334 21.566L19.6335 21.5659L19.6336 21.5658C21.5583 19.8065 25.2775 16.4068 25.3714 16.0134C25.3868 15.9488 25.4011 15.7082 25.2557 15.5812C25.1103 15.4541 24.8958 15.4976 24.741 15.5321C24.5215 15.5811 21.0259 17.8528 14.2541 22.3472C13.2618 23.0171 12.3631 23.3435 11.5579 23.3264C10.6702 23.3075 8.96262 22.8329 7.69322 22.4272C7.50698 22.3677 7.32531 22.3115 7.14997 22.2573L7.14943 22.2571C5.85918 21.8582 4.91169 21.5653 5.00654 20.8214C5.06267 20.3812 5.67919 19.931 6.85611 19.4709Z"
                    fill="#E8E8E8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_4365_194939">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <a
              href="https://www.facebook.com/wjet.io"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="socialMediaIcons" clip-path="url(#clip0_2407_31644)">
                  <path
                    id="Vector"
                    d="M20 0C8.9544 0 0 8.9544 0 20C0 29.3792 6.4576 37.2496 15.1688 39.4112V26.112H11.0448V20H15.1688V17.3664C15.1688 10.5592 18.2496 7.404 24.9328 7.404C26.2 7.404 28.3864 7.6528 29.2808 7.9008V13.4408C28.8088 13.3912 27.9888 13.3664 26.9704 13.3664C23.6912 13.3664 22.424 14.6088 22.424 17.8384V20H28.9568L27.8344 26.112H22.424V39.8536C32.3272 38.6576 40.0008 30.2256 40.0008 20C40 8.9544 31.0456 0 20 0Z"
                    fill="#E8E8E8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2407_31644">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>

          <div className="newfooter__details">
            <div className="newfooter__detailsleft">
              {/* <a href="tel:+79994567876">+7 999 456 78 76</a> */}
              <a href="mailto:contact@wjet.io">contact@wjet.io</a>
              <div>Минск &#x7c; Dubai</div>
            </div>

            <div className="newfooter__policy">
              <div>Все права защищены 2022 – 2025</div>
              <a href="#">Политика конфиденциальности</a>
            </div>
          </div>
        </div>
      </footer>

      <ContactUsModal />
    </div>
  );
};
